module.exports = __webpack_public_path__ + "static/img/Group3465688.881dcc93.png";